<template>
  <v-card flat height="100"></v-card>
</template>

<script>
export default {
  mounted() {
    this.$store.commit("setPageTitle", "Report");
  },
};
</script>

<style>
</style>